import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {GLOBAL_ADMIN_READ, GLOBAL_ADMIN_WRITE, useAuthStore} from '@/context/auth';
import Forbidden from './Forbidden';

/**
 * 对与 Route 的封装，增加 onAuthorities 字段用于控制权限。
 *
 * react-router v6 迁移：不再内部渲染 <Route>，改为包裹 children 的纯权限容器，
 * 由调用方在 <Route element={...}> 中使用（v6 的 <Routes> 只识别直接的 <Route> 子元素）。
 *
 * @param onAuthorities 此路由支持的权限列表
 * @param children 有权限时渲染的内容
 * @return {JSX.Element|null}
 * @constructor
 */
export default function AuthRoute({onAuthorities, children}) {
    const [authStore] = useAuthStore();

    // 没有提供支持的权限，则正常渲染
    if (_.isEmpty(onAuthorities)) {
        return children;
    }

    const userAuths = _.get(authStore, 'authorities', []) ?? [];
    if (userAuths.includes(GLOBAL_ADMIN_READ) || userAuths.includes(GLOBAL_ADMIN_WRITE)) {
        return children;
    }

    for (const auth of onAuthorities) {
        if (userAuths.includes(auth)) {
            return children;
        }
    }

    // 没有权限则不渲染相应 route
    return <Forbidden />;
}

AuthRoute.propTypes = {
    // 支持的授权列表
    onAuthorities: PropTypes.arrayOf(PropTypes.string),

    children: PropTypes.node,
};
